import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

const PINE = "#2f5d3a"
const PAPER_2 = "#efe7d6"

export default class extends Controller {
  static values = { completed: Number, total: Number }

  connect() {
    const hasParticipants = this.totalValue > 0
    const remaining = Math.max(this.totalValue - this.completedValue, 0)

    this.chart = new Chart(this.element, {
      type: "doughnut",
      data: {
        labels: hasParticipants ? ["Completed", "Remaining"] : ["No participants yet"],
        datasets: [{
          data: hasParticipants ? [this.completedValue, remaining] : [1],
          backgroundColor: hasParticipants ? [PINE, PAPER_2] : [PAPER_2],
          borderWidth: 0
        }]
      },
      options: {
        cutout: "70%",
        plugins: {
          legend: { display: false },
          tooltip: { enabled: hasParticipants }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
